import { useEffect, useState } from "react";
import { useBenchmarks, useUrlState } from "../../hooks";
import { Benchmark } from "../../hooks/useBenchmarks";
import { CategoryPage } from "./CategoryPage";
import { HomePage } from "./HomePage";
import { AnalyticsProps } from "./types";
import { CalculationType, Category } from "./../../types";

import "./index.scss";

export const Analytics = ({
  rawData,
  currentTestId,
  selectedFilters,
}: AnalyticsProps) => {
  const {
    updatePath,
    path: { category, cubeSide },
  } = useUrlState();

  const { benchmarks } = useBenchmarks({
    currentTestId,
    rawData,
    category: category as Category,
    cubeSide: cubeSide,
  });
  const [selectedBenchmark, setSelectedBenchmark] = useState<
    Benchmark | undefined
  >(benchmarks[0]);
  const [selectedCalculationType, setSelectedCalculationType] =
    useState<CalculationType>(CalculationType.Benchmark);

  function navigateBackToMarketOverview() {
    updatePath({ category: undefined, cubeSide: undefined });
  }

  useEffect(() => {
    if (selectedBenchmark) {
      // Search in root level
      let foundBenchmark = benchmarks.find(b => b.id === selectedBenchmark.id);

      // If not found in root, search in children
      if (!foundBenchmark) {
        for (const benchmark of benchmarks) {
          if (benchmark.children) {
            foundBenchmark = benchmark.children.find(
              child => child.id === selectedBenchmark.id
            );
            if (foundBenchmark) break;
          }
        }
      }
      setSelectedBenchmark(foundBenchmark);
    }
  }, [benchmarks, selectedBenchmark]);

  return (
    <div className="analytics-module">
      {category ? (
        <CategoryPage
          category={category}
          onHomeClick={navigateBackToMarketOverview}
          selectedFilters={selectedFilters}
          setSelectedBenchmark={setSelectedBenchmark}
          benchmarks={benchmarks}
          selectedBenchmark={selectedBenchmark}
          currentTestId={currentTestId}
          rawData={rawData}
          selectedCalculationType={selectedCalculationType}
          setSelectedCalculationType={setSelectedCalculationType}
        />
      ) : (
        <HomePage
          selectedFilters={selectedFilters}
          setSelectedBenchmark={setSelectedBenchmark}
          benchmarks={benchmarks}
          selectedBenchmark={selectedBenchmark}
          currentTestId={currentTestId}
          rawData={rawData}
          selectedCalculationType={selectedCalculationType}
          setSelectedCalculationType={setSelectedCalculationType}
        />
      )}
    </div>
  );
};
